var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddchapter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 8.375C11.1562 8.01257 10.8624 7.71875 10.5 7.71875C10.1376 7.71875 9.84375 8.01257 9.84375 8.375V10.3437H7.875C7.51257 10.3437 7.21875 10.6376 7.21875 11C7.21875 11.3624 7.51257 11.6562 7.875 11.6562H9.84375V13.625C9.84375 13.9874 10.1376 14.2812 10.5 14.2812C10.8624 14.2812 11.1562 13.9874 11.1562 13.625V11.6562H13.125C13.4874 11.6562 13.7812 11.3624 13.7812 11C13.7812 10.6376 13.4874 10.3437 13.125 10.3437H11.1562V8.375Z",
    fill: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 1.59326C5.30507 1.59326 1.09375 5.80458 1.09375 10.9995C1.09375 16.1945 5.30507 20.4058 10.5 20.4058C15.695 20.4058 19.9062 16.1945 19.9062 10.9995C19.9062 5.80458 15.695 1.59326 10.5 1.59326ZM2.40625 10.9995C2.40625 6.52946 6.02995 2.90576 10.5 2.90576C14.97 2.90576 18.5938 6.52946 18.5938 10.9995C18.5938 15.4695 14.97 19.0933 10.5 19.0933C6.02995 19.0933 2.40625 15.4695 2.40625 10.9995Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddchapter);
export default __webpack_public_path__ + "static/media/Add chapter.c6c7ac8861f0b19be743a625c0911a92.svg";
export { ForwardRef as ReactComponent };